<template>
    <div>
        <preloader v-show="loading"></preloader>
        <success-screen
            v-if="sended && sendedSuccess"
            title="Ваша заявка принята!"
        >
            <p class="p1">
                Ожидайте SMS-сообщение от банка.
            </p>
            <p class="p1">
                В случае возникновения вопросов с вами свяжется сотрудник
            </p>
            <template #append>
                <a
                    v-if="wayToGet === EWayToGet.OFFICE"
                    class="button button_green"
                    target="_blank"
                    href="/location/"
                >
                    Офисы банка
                </a>
            </template>
        </success-screen>
        <success-screen
            v-if="sended && !sendedSuccess"
            title="Неизвестная ошибка"
            description="Повторите попытку позже"
            is-error
        >
            <template #append>
                <a
                    v-if="wayToGet === EWayToGet.OFFICE"
                    class="button button_green"
                    target="_blank"
                    href="/location/"
                >
                    Офисы банка
                </a>
            </template>
        </success-screen>
		<div v-if="!sended" class="_br-56-24 _bg-grey-106 _pt-56-24 _pb-56-24 _pl-56-16 _pr-56-16">

            <div class="h2 _mb-32-24">Подайте заявку на получение стикера ДОМPay </div>

            <div
                v-if="currentStep === 1"
                class="_dflex _flexdir-column _gap-40-32"
            >

                <div class="_dflex _flexwrap _gap-40-32">
                    <div class="_flex-auto">
                        <div class="h3">Укажите личные данные</div>
                    </div>
                    <div class="_flex-none _w-584-full">
                        <div class="form__row">
                            <div class="form__col">
                                <ui-form-field
                                    label="Фамилия"
                                    :errors="vuelidateErrorMesages.lastName"
                                    :value="$v.lastName.$model"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <UiTextInputSuggestions
                                            :id="id"
                                            :error="!!errors.length"
                                            v-model="$v.lastName.$model"
                                            name="lastName"
                                            :suggestionType="ESuggestionTypes.NAME"
                                            :suggestionPatrs="[EFioParts.SURNAME]"
                                            :count="3"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                            <div class="form__col">
                                <ui-form-field
                                    label="Имя"
                                    :errors="vuelidateErrorMesages.firstName"
                                    :value="$v.firstName.$model"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <UiTextInputSuggestions
                                            :id="id"
                                            :error="!!errors.length"
                                            v-model="$v.firstName.$model"
                                            name="firstName"
                                            :suggestionType="ESuggestionTypes.NAME"
                                            :suggestionPatrs="[EFioParts.NAME]"
                                            :count="3"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col">
                                <ui-form-field
                                    label="Отчество"
                                    :errors="vuelidateErrorMesages.middleName"
                                    :value="$v.middleName.$model"
                                    class="_mb-32-32"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <UiTextInputSuggestions
                                            :id="id"
                                            :error="!!errors.length"
                                            v-model="$v.middleName.$model"
                                            name="middleName"
                                            :suggestionType="ESuggestionTypes.NAME"
                                            :suggestionPatrs="[EFioParts.PATRONYMIC]"
                                            :count="3"
                                            :disabled="hasntMiddleName"
                                        />
                                    </template>
                                </ui-form-field>
                                <ui-form-field
                                    :value="hasntMiddleName"
                                >
                                    <template v-slot:default="{ id }">
                                        <ui-checkbox
                                            v-model="hasntMiddleName"
                                            :id="id"
                                            label="Нет отчества"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                            <div class="form__col">
                                <ui-form-field
                                    label="Дата рождения"
                                    :value="$v.birthDate.$model"
                                    id="birthDate"
                                    :errors="vuelidateErrorMesages.birthDate"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <ui-date-picker
                                            :id="id"
                                            :error="!!errors.length"
                                            v-model="$v.birthDate.$model"
                                            name="birthDate"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col">
                                <ui-form-field
                                    label="E-mail"
                                    :errors="vuelidateErrorMesages.email"
                                    :value="$v.email.$model"
                                    id="cards-form-email"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <UiTextInputSuggestions
                                            :id="id"
                                            :error="!!errors.length"
                                            v-model="$v.email.$model"
                                            name="email"
                                            :suggestionType="ESuggestionTypes.EMAIL"
                                            :count="3"
                                            :lazy="errors.length === 0"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                            <div class="form__col">
                                <ui-form-field
                                    label="Телефон"
                                    :errors="vuelidateErrorMesages.phone"
                                    :value="$v.phone.$model"
                                    id="phone"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <ui-text-input-masked
                                            :id="id"
                                            :error="errors.length > 0"
                                            v-model="$v.phone.$model"
                                            mask="+7 ### ###-##-##"
                                            placeholder="+7"
                                            type="tel"
                                            name="phone"
                                            :lazy="errors.length === 0"
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col form__col_1-1">
                                <ui-form-field
                                    label="Последние 4 цифры номера карты"
                                    :errors="vuelidateErrorMesages.cardNum"
                                    :value="$v.cardNum.$model"
                                    class="_mb-16"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <ui-text-input-masked
                                            :id="id"
                                            :error="errors.length > 0"
                                            v-model="$v.cardNum.$model"
                                            pattern="\d*"
                                            mask="####"
                                        />
                                    </template>
                                </ui-form-field>
                                <p class="p2 text-gray">Введите последние 4 цифры номера карты, к которой будет выпущен стикер</p>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__col form__col_1-1">
                                <ui-form-field
                                    :errors="vuelidateErrorMesages.agreement"
                                    :value="$v.agreement.$model"
                                >
                                    <template v-slot:default="{ id }">
                                        <ui-checkbox
                                            v-model="$v.agreement.$model"
                                            :id="id"
                                        >
                                            <template #label>
                                                Я соглашаюсь с&nbsp;<a href="#" @click.stop.prevent="$modal.show('debit-card-agreement')" class="link">условиями&nbsp;использования персональных&nbsp;данных</a> и&nbsp;подтверждаю согласие на&nbsp;использование <a href="#" @click.stop.prevent="$modal.show('agreement-pep')" class="link">простой электронной подписи</a>
                                            </template>
                                        </ui-checkbox>
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MeetingForm
                v-if="currentStep === 2"
                ref="meetingFormRef"
                :product-code="PRODUCT_CODE"
                :region.sync="region"
                :city.sync="city"
                :office.sync="office"
                :way-to-get.sync="wayToGet"
                noDateTime
                noAddress
                @status="(status) => meetingInvalid = status === EMeetingValidationStatus.INVALID"
                @city-title="(val) => cityTitle = val"
                @delivery-type="(val) => deliveryType = val"
                @unavailable-office-pending="(val) => loading = val"
            ></MeetingForm>
            <div class="_dflex _flexwrap _gap-40-32">
                <div class="_flex-auto" />
                <div class="_flex-none _w-584-full">
                    <div class="form__row">
                        <div class="button button_green" @click="onContinue">Продолжить</div>
                    </div>

                    <div class="form__lock escrow-about-get-feedback__footer">
                        <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-16"></span>
                        <span class="text-small form__lock-text text-gray">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без Вашего согласия на это, если иное не предусмотрено законодательством</span>
                    </div>
                </div>
            </div>
        </div>

        <d-modal
            v-cloak
            name="debit-card-agreement"
            popup-title="Согласие заявителя"
            size="wide"
        >
            <p class="d-modal__text p1 _pr-40">
                <slot name="debit-card-agreement" />
            </p>
        </d-modal>
        <d-modal
            v-cloak
            name="agreement-pep"
            popup-title="Соглашение об использовании простой электронной подписи"
            size="wide"
        >
            <p class="d-modal__text p1 _pr-40">
                <slot name="agreement-pep" />
            </p>
        </d-modal>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate';
    import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
    import {
        cyrWithDash, phoneLength, seemsDigitInPhone,
    } from '../../assets/js/vue/validations'
    import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
    import vuelidateMessages from '../../assets/js/vue/validationsMessages';
    import dayjs from 'dayjs';
    import { scrollToElem } from '../../assets/js/utils';
    import { EFioParts } from '../../assets/js/vue/utlis/useDadata/utils/EFioParts';
    import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';
    import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';
    import SuccessScreen from '../../components/SuccessScreen.vue';
    import MeetingForm from '../widgets/MeetingForm/MeetingForm.vue';
    import { EWayToGet, EValidationStatus as EMeetingValidationStatus, EMBProductCode, } from '../widgets/MeetingForm/const';
    import { waitPhoneCode } from '../../assets/js/handleOtpExpired';
    import { paymentSticker } from '../../api/paymentSticker';

    const PRODUCT_CODE = EMBProductCode.STICKER;

    let isBetween = require('dayjs/plugin/isBetween')
    dayjs.extend(isBetween);

    export default {
        name: 'StickerForm',
        mixins: [validationMixin],
        components: {
            UiTextInputSuggestions,
            SuccessScreen,
            MeetingForm,
        },
        data() {
            return {
                firstName: '',
                lastName: '',
                middleName: '',
                birthDate: '',
                phone: '',
                email: '',
                loading: false,
                sended: false,
                sendedSuccess: false,
                agreement: false,
                hasntMiddleName: false,
                currentStep: 1,
                city: '',
                cityTitle: '',
                office: '',
                cardNum: '',
                region: '',
                EFioParts,
                ESuggestionTypes,
                age: {
                    min: {
                        type: 'year',
                        value: 18,
                    },
                    max: {
                        type: 'year',
                        value: 120,
                    }
                },
                PRODUCT_CODE,
                wayToGet: EWayToGet.OFFICE,
                EMeetingValidationStatus,
                meetingInvalid: false,
                deliveryType: '',
                EWayToGet,
            };
        },
		validations() {
			return {
                firstName: {
                    required: required,
                    cyrWithDash: cyrWithDash,
                    maxLength: maxLength(255),
                },
                lastName: {
                    required: required,
                    cyrWithDash: cyrWithDash,
                    maxLength: maxLength(255),
                },
                middleName: {
                    required: !this.hasntMiddleName ? required : () => true,
                    cyrWithDash: cyrWithDash,
                    maxLength: maxLength(255),
                },
                birthDate: {
                    required: required,
                    ageRange: (val) => {
                        if (!val) return true;
                        let age = dayjs(this.convertDateToEng(val));
                        let minAge = age.add(this.age.min.value, this.age.min.type);
                        let maxAge = age.add(this.age.max.value, this.age.max.type);

                        return dayjs().isBetween(minAge, maxAge);
                    }
                },
                email: {
                    required: required,
                    email: email,
                    maxLength: maxLength(100),
                },
                phone: {
                    required: required,
                    phoneLength: phoneLength,
                    seemsDigitInPhone: seemsDigitInPhone
                },
                agreement: {
                    isAgreed: (val) => !!val,
                },
                cardNum: {
                    required,
                    minLength: minLength(4),
                },
			};
		},
        computed: {
            namespace() {
                return 'paymentStickerForm';
            },
            vuelidateErrorMesages() {
                return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
            },
        },
        methods: {
            async onContinue() {
                switch (this.currentStep) {
                    case 1:
                        if (!this.validateStepOne()) return;
                        await waitPhoneCode(this.namespace, this.phone)
                            .then(() => {
                                this.currentStep++;
                            });
                        break;
                    case 2:
                        this.$refs.meetingFormRef?.validate();
                        if (this.meetingInvalid) return;
                        this.sendForm();
                        break;
                    default:
                        break;
                }
            },
            validateStepOne() {
                this.$v.lastName.$touch();
                this.$v.firstName.$touch();
                this.$v.middleName.$touch();
                this.$v.phone.$touch();
                this.$v.email.$touch();
                this.$v.birthDate.$touch();
                this.$v.agreement.$touch();
                this.$v.cardNum.$touch();

                return !this.$v.$error;
            },
            async sendForm() {
                this.loading = true;

                const data = {
                    attributes: {
                        surname: this.lastName,
                        name: this.firstName,
                        patronymic: this.middleName,
                        birthdate: this.birthDate,
                        email: this.email,
                        cardNum: this.cardNum,
                        phone: this.phone.replace(/\D/g, ''),
                        agreement: this.agreement,
                        appointment: {
                            product: PRODUCT_CODE,
                            region: this.region,
                            city: this.wayToGet === EWayToGet.DELIVERY ? this.cityTitle : this.city,
                            deliveryType: this.deliveryType,
                        },
                    },
                    type: "paymentStickerForm"
                }

                if (this.wayToGet === EWayToGet.OFFICE) {
                    data.attributes.appointment.office = this.office;
                }

                return paymentSticker(data)
                    .then(() => {
                        this.sendedSuccess = true;
                        this.sended = true;
                        if (window.dmpkitdl) window.dmpkitdl.push({event: 'sticker-full-form-send'});
                    })
                    .catch((e) => {
                        if (e.response.status === 429) {
                            this.$modal.show('tooManyRequests');
                        } else {
                            this.sended = true;
                            return Promise.reject(e);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        scrollToElem('card_order_form');
                    });
            },
            convertDateToEng(val) {
                return val.replace(/\./g, '-').split('-').reverse().join('-');
            }
        },
    }
</script>
<style lang="scss">
@import '../../assets/scss/pages/escrow/escrow-about-get-feedback.scss';
</style>
